<template>
  <div class="container-fluid">
    <PageHeader :title="title" :items="items" />
    <b-form @submit.prevent="onSubmit()">
      <div class="row" v-if="solicitacao">
        <div class="card">
          <div class="card-body">
            <b-alert show dismissible variant="danger" v-if="alert.erro">
              <ul v-for="err in msg.erro" :key="err">
                <li>{{ err }}</li>
              </ul>
            </b-alert>
            <div class="row">
              <div class="col-md-12">
                <b-form-group
                  class="mb-3"
                  label="Veículos"
                  label-for="lkp-tipo-solicitacao"
                >
                  <multiselect
                    :class="{
                      'is-invalid': !solicitacaoViculo.nrPlaca && check,
                    }"
                    value=""
                    v-model="veiculo"
                    :options="veiculos"
                    :custom-label="nameWithLang"
                    placeholder="Selecione..."
                    selectLabel=""
                    deselectLabel=""
                    @input="checkVeiculo(veiculo.nr_placa)"
                    @remove="removeCheckVeiculo()"
                  >
                  </multiselect>
                  <div
                    v-if="!solicitacaoViculo.nrPlaca && check"
                    class="invalid-feedback"
                  >
                    <span v-if="!solicitacaoViculo.nrPlaca && check"
                      >Selecione um veículo.</span
                    >
                  </div>
                </b-form-group>
              </div>
            </div>
            <div class="row" >
              <div class="col-lg-12">
                <b-card
                  no-body
                  :class="{
                    'border border-danger':
                      (!marcaCheck || !modeloCheck || !versaoCheck) && check,
                  }"
                  class="mb-1"
                >
                  <b-row no-gutters class="align-items-center">
                    <b-col md="5">
                      <b-card-body :title="solicitacao.nm_razao_coop">
                        <b-card-text
                          >{{ solicitacao.nm_projeto }}. <br />
                          {{ solicitacao.nm_regiao_entrega }}.</b-card-text
                        >
                        <p class="card-text">
                          <small class="text-muted"
                            >Data entrega: {{ solicitacao.dt_entrega }} <br />
                            Data devolução:
                            {{ solicitacao.dt_devolucao }}</small
                          >
                        </p>
                      </b-card-body>
                    </b-col>
                    <b-col md="5">
                      <b-card-body>
                        <b-card-text>
                          <i
                            style="color: green"
                            class="
                              bx bx bx-check-circle
                              font-size-16
                              align-middle
                              me-2
                            "
                            v-if="marcaCheck"
                          ></i>
                          <i
                            style="color: red"
                            class="
                              bx bx-x-circle
                              font-size-16
                              align-middle
                              me-2
                            "
                            v-else
                          ></i
                          >MARCA: <b> {{ solicitacao.nm_marca }}</b>
                        </b-card-text>
                        <b-card-text
                          ><i
                            style="color: green"
                            class="
                              bx bx bx-check-circle
                              font-size-16
                              align-middle
                              me-2
                            "
                            v-if="modeloCheck"
                          ></i>
                          <i
                            style="color: red"
                            class="
                              bx bx-x-circle
                              font-size-16
                              align-middle
                              me-2
                            "
                            v-else
                          ></i
                          >MODELO:
                          <b> {{ solicitacao.nm_modelo }}</b></b-card-text
                        >
                        <b-card-text
                          ><i
                            style="color: green"
                            class="
                              bx bx bx-check-circle
                              font-size-16
                              align-middle
                              me-2
                            "
                            v-if="versaoCheck"
                          ></i>
                          <i
                            style="color: red"
                            class="
                              bx bx-x-circle
                              font-size-16
                              align-middle
                              me-2
                            "
                            v-else
                          ></i
                          >VERSÃO:
                          <b> {{ solicitacao.nm_versao }}</b></b-card-text
                        >
                      </b-card-body>
                    </b-col>
                    <b-col md="2">
                      {{solicitacao.cd_marca}}
                      <b-card-img
                        :src="
                          require(`@/assets/images/logo-marcas/${solicitacao.cd_marca}.svg`)
                        "
                        class="rounded-0"
                        style="width: 38%"
                      ></b-card-img>
                    </b-col>
                  </b-row>
                </b-card>
                <div
                  v-if="(!marcaCheck || !modeloCheck || !versaoCheck) && check"
                  class="invalid-feedback d-block"
                >
                  <span
                    v-if="
                      (!marcaCheck || !modeloCheck || !versaoCheck) && check
                    "
                    >Selecione um veículo que atenda os requisitos.</span
                  >
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-12">
                <b-form-group
                  class="mb-3"
                  label="Observações"
                  label-for="textarea-obs"
                >
                  <b-form-textarea
                    id="textarea-obs"
                    v-model="solicitacaoViculo.dsObs"
                    rows="3"
                  ></b-form-textarea>
                </b-form-group>
              </div>
            </div>
            <div class="row mt-2">
              <div class="button-items">
                <b-button
                  size="lg"
                  variant="primary"
                  type="submit"
                  v-if="!isBtnSubmited"
                >
                  <i class="bx bx-send font-size-16 align-middle me-2"></i>
                  Enviar
                </b-button>
                <b-button size="lg" variant="primary" disabled v-else>
                  <b-spinner small></b-spinner>
                  Carregando...
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";

export default {
  page: {
    title: "Solicitação Veículo",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Solicitação",
      items: [
        {
          text: "Locadora",
          active: false,
        },
        {
          text: "Solicitações",
          href: "/locadora/solicitacao",
        },
        {
          text: "Solicitação",
          active: false,
        },
      ],
      sqSolVei: this.$route.params.id,
      veiculos: [],
      veiculo: null,
      solicitacao: null,
      marcaCheck: false,
      modeloCheck: false,
      versaoCheck: false,
      isBtnSubmited: false,
      check: false,
      msg: {
        erro: [],
      },
      alert: {
        erro: false,
      },
      solicitacaoViculo: {
        sqUsuario: this.$store.state.user,
        cdTpPessoa: null,
        cdPessoa: null,
        sqSolvei: null,
        nrPlaca: null,
        dsObs: null,
      },
    };
  },
  created() {
    this.getDataSolicitacao();
  },
  methods: {
    getVeiculos() {
      this.$http
        .get("api/veiculo")
        .then((response) => {
          this.veiculos = [];
          response.data.forEach(el => {
            if(el.cd_pessoa == this.solicitacao.cd_pessoa_prop && el.st_ativo == 'S'){
              this.veiculos.push(el);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDataSolicitacao() {
      this.$http
        .get(`api/veiculo/solicitacao/${this.sqSolVei}`)
        .then((response) => {
          this.solicitacao = response.data;
          this.solicitacaoViculo.cdPessoa = response.data.cd_pessoa_prop;
          this.solicitacaoViculo.sqSolvei = response.data.sq_solvei;
          this.solicitacaoViculo.cdTpPessoa = response.data.cd_tp_pessoa_prop;
          this.getVeiculos();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    nameWithLang({ nr_placa, nm_marca, nm_modelo, nm_versao }) {
      return `${nr_placa} - ${nm_marca} - ${nm_modelo} - ${nm_versao}`;
    },
    checkVeiculo(placa) {
      this.$http
        .get(`api/veiculo/${placa}`)
        .then((response) => {
          this.solicitacaoViculo.nrPlaca = response.data.nr_placa;

          response.data.cd_marca == this.solicitacao.cd_marca
            ? (this.marcaCheck = true)
            : (this.marcaCheck = false);

          response.data.sq_modelo == this.solicitacao.sq_modelo
            ? (this.modeloCheck = true)
            : (this.modeloCheck = false);

          response.data.sq_versao == this.solicitacao.sq_versao
            ? (this.versaoCheck = true)
            : (this.versaoCheck = false);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeCheckVeiculo() {
      this.solicitacaoViculo.nrPlaca = null;
      this.marcaCheck = false;
      this.modeloCheck = false;
      this.versaoCheck = false;
    },
    onSubmit() {
      this.alert.erro = false;
      this.msg.erro = [];

      this.check = true;

      if (
        !this.solicitacaoViculo.nrPlaca ||
        !this.marcaCheck ||
        !this.modeloCheck ||
        !this.versaoCheck
      ) {
        return false;
      }

      this.isBtnSubmited = true;

      this.$http
        .post("api/veiculo/solicitacao", this.solicitacaoViculo)
        .then(() => {
          this.check = false;
          this.alert.erro = false;
          this.msg.erro = [];
          this.$router.push(`/locadora/solicitacao`);
        })
        .catch((err) => {
          this.isBtnSubmited = false;
          this.check = false;
          this.alert.erro = true;
          this.msg.erro.push(err.response.data.message);
        });
    },
  },
};
</script>

<style>
.is-valid .multiselect__tags {
  border-color: #34c38f !important;
}
.is-invalid .multiselect__tags {
  border-color: #f46a6a !important;
}

.is-valid .mx-input {
  border-color: #34c38f !important;
}

.is-invalid .mx-input {
  border-color: #f46a6a !important;
}
</style>

